export const ThemeModeEnum = {
  LIGHT: "light",
  DARK: "dark",
};
